<form action="#" autocomplete="off" (submit)="addTag()">
  <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="start center">
    <span fxFlex="20">Titulo del tag: </span>
    <mat-form-field fxFlex>
      <input matInput type="text" placeholder="Titulo" [formControl]="tagName" [matAutocomplete]="tagAutocomplete" />
      <mat-autocomplete autoActiveFirstOption #tagAutocomplete="matAutocomplete">
        <mat-option *ngFor="let tag of filteredTags | async; let i = index" [value]="tag.name">
          <div class="d-flex align-items-center justify-content-between">
            <span>{{ tag.name }}</span>
            <a mat-icon-button (click)="removeTag(tag, i)">
              <i class="material-icons">close</i>
            </a>
          </div>
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="tagName.hasError('required')">
        Nombre del tag requerido
      </mat-error>
    </mat-form-field>
    <!-- <a mat-stroked-button color="primary" (click)="addNewTag()"
      ><i class="material-icons">add</i>AGREGAR TAG</a
    > -->
  </div>
  <div class="actions w-100" fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="end center">
    <button type="submit" mat-raised-button color="primary" [disabled]="!tagName.valid">
      Guardar
    </button>
  </div>
</form>